// extracted by mini-css-extract-plugin
export default {"root":"BlogsPage_root__yz-Qm","button":"BlogsPage_button__PkfS-"};